// import images
import LogoImg from '../src/assets/img/header/logo.png';
import HeroImg from '../src/assets/img/hero/Hero.png';
import OverviewProductImg from '../src/assets/img/overview/product.svg';
import FacebookImg from '../src/assets/img/overview/brands/facebook.svg';
import GoogleImg from '../src/assets/img/overview/brands/google.svg';
import CocaColaImg from '../src/assets/img/overview/brands/coca-cola.svg';
import LinkedInImg from '../src/assets/img/overview/brands/linkedin.svg';
import SamsungImg from '../src/assets/img/overview/brands/samsung.svg';
import Feature1Img from '../src/assets/img/features/feature1-img.svg';
import Feature2Img from '../src/assets/img/features/disclaimer.png';
import Feature3Img from '../src/assets/img/features/feature3-img.svg';
import ArrowRightImg from '../src/assets/img/features/arrow-right.svg';
import CardIconImg1 from '../src/assets/img/product/cards/icon1.svg';
import CardIconImg2 from '../src/assets/img/product/cards/icon2.svg';
import CardIconImg3 from '../src/assets/img/product/cards/icon3.svg';
import PricingIcon1 from '../src/assets/img/pricing/fbs.svg';
import PricingIcon2 from '../src/assets/img/pricing/xm.svg';
import PricingIcon3 from '../src/assets/img/pricing/exness.svg';
import PricingIcon4 from '../src/assets/img/pricing/logo-litefinance.svg';
import AvatarImg1 from '../src/assets/img/testimonial/avatar1.png';
import AvatarImg2 from '../src/assets/img/testimonial/avatar2.png';
import AvatarImg3 from '../src/assets/img/testimonial/avatar3.png';
// import AvatarImg4 from '../src/assets/img/testimonial/avatar4.png';
// import AvatarImg5 from '../src/assets/img/testimonial/avatar5.png';
// import CtaImg1 from '../src/assets/img/cta/image1.svg';
// import CtaImg2 from '../src/assets/img/cta/image2.svg';
import FacebookIcon from '../src/assets/img/copyright/facebook.svg';
import TwitterIcon from '../src/assets/img/copyright/twitter.svg';
import LinkedinIcon from '../src/assets/img/copyright/linkedin.svg';

export const header = {
  logo: LogoImg,
  btnText: 'Log in',
};

export const nav = [
  { name: 'Open Account', href: '/open-account' },
  { name: 'VPS', href: '/vps' },
  { name: 'Demo', href: '/demo' },
  { name: 'Economic Calendar', href: '/e-calendar' },
  { name: 'Market Sentiment', href: '/market-sentiment' },
  { name: 'Testimonials', href: '/testimonials' },
];

export const hero = {
  title: 'FREE EA FREE VPS',
  subtitle1: 'Free EA lifetime,',
  subtitle2: 'Free VPS - 3 months',
  btnText: 'Register Now',
  compText: '',
  image: HeroImg,
}

export const overview = {
  productImg: OverviewProductImg,
  brands: [
    {
      image: FacebookImg,
      delay: 300,
    },
    {
      image: GoogleImg,
      delay: 400,
    },
    {
      image: CocaColaImg,
      delay: 500,
    },
    {
      image: LinkedInImg,
      delay: 600,
    },
    {
      image: SamsungImg,
      delay: 700,
    },
  ],
};

export const features = {
  feature1: {
    pretitle: 'Alwalys online',
    title: 'Real-time support with cloud',
    subtitle:
      'Tellus lacus morbi sagittis lacus in. Amet nisl at mauris enim accumsan nisi, tincidunt vel. Enim ipsum, amet quis ullamcorper eget ut.',
    btnLink: 'Learn more',
    btnIcon: ArrowRightImg,
    image: Feature1Img,
  },
  feature2: {
    pretitle: 'Free some cost',
    title1: 'Trading in FOREX MARKET involves risk. This is not a solicitation for investment of any kind. One should learn all the risks associated with trading before getting involved, even when using trade software, copy trading or subscribing to a signal provider.',
    title2: 'Past performance is not indicative of future results. A trader who has been successful for substantial period of time may not always successful. All earning described in this site will vary depending in market stability, your strategy, and your work ethics you spend on educating yourself.',
    subtitle:
      'Tellus lacus morbi sagittis lacus in. Amet nisl at mauris enim accumsan nisi, tincidunt vel. Enim ipsum, amet quis ullamcorper eget ut.',
    btnLink: 'Learn more',
    btnIcon: ArrowRightImg,
    image: Feature2Img,
  },
  feature3: {
    pretitle: 'Use anytime',
    title: 'Use anytime when you need',
    subtitle:
      'Tellus lacus morbi sagittis lacus in. Amet nisl at mauris enim accumsan nisi, tincidunt vel. Enim ipsum, amet quis ullamcorper eget ut.',
    btnLink: 'Learn more',
    btnIcon: ArrowRightImg,
    image: Feature3Img,
  },
};

export const product = {
  title: 'The Product we work with.',
  subtitle:
    'Tellus lacus morbi sagittis lacus in. Amet nisl at mauris enim aumsan nisi, tincidunt vel. Enim ipsum, at quis ullamcorper eget ut.',
  cards: [
    {
      icon: CardIconImg1,
      title: 'Cross platform',
      subtitle: 'Elit esse cillum dolore eu fugiat nulla pariatur',
      delay: 200,
    },
    {
      icon: CardIconImg2,
      title: 'Cloud server',
      subtitle: 'Elit esse cillum dolore eu fugiat nulla pariatur',
      delay: 400,
    },
    {
      icon: CardIconImg3,
      title: 'Pure Javascript',
      subtitle: 'Elit esse cillum dolore eu fugiat nulla pariatur',
      delay: 600,
    },
    {
      icon: CardIconImg3,
      title: 'Pure Javascript',
      subtitle: 'Elit esse cillum dolore eu fugiat nulla pariatur',
      delay: 600,
    },
  ],
};

export const pricing = {
  title: 'Choose your preferred broker.',
  cards: [
    {
      icon: PricingIcon1,
      title: '',
      services: [
        { name: 'Minimum capital for Standard $3000' },
        { name: 'Minimum capital for Cent $500' },
        { name: 'Cent Account and Standard Account' },

      ],
      price: '',
      userAmount: '',
      btnText: 'Open Account',
      link: 'https://fbs.partners?ibl=1281&ibk=TraderDoPH',
      delay: 300,
    },
    {
      icon: PricingIcon2,
      title: '',
      services: [
        { name: 'Minimum capital for Standard $3000' },
        { name: 'Minimum capital for Micro $500' },
        { name: 'Micro Account and Standard Account' },
      ],
      price: '',
      userAmount: '',
      btnText: 'Open Account',
      link: 'https://clicks.pipaffiliates.com/c?c=569610&l=en&p=1',
      delay: 600,
    },
    {
      icon: PricingIcon3,
      title: '',
      services: [
        { name: 'Minimum capital for Zero $200' },
        { name: 'Minimum capital for Pro $200' },
        { name: 'Pro Account and Zero Account' },
      ],
      price: '',
      userAmount: '',
      btnText: 'Open Account',
      link: 'https://one.exness.link/boarding/sign-up/a/ynm4lry275',
      delay: 900,
    },
    {
      icon: PricingIcon4,
      title: '',
      services: [
        { name: 'Minimum capital for Standard $3000' },
        { name: 'Minimum capital for Cent $500' },
        { name: 'Cent Account and Standard Account' },
      ],
      price: '',
      userAmount: '',
      btnText: 'Open Account',
      link: 'https://www.litefinance.org/?uid=704412251',
      delay: 900,
    },
  ],
};

export const testimonials = {
  title: 'We have thousands of best wishers',
  clients: [
    {
      message:
        'Im very satisfied with TDP. Even with high DD my account survived. ???? i am grateful i belong to this group and im happy i got to have another source of income especially this pandemic. I believe in the admins of TDP because they really know their craft and that adds to my confidence and trust in TDP with its system rakkpro. I give them 5 stars.',
      image: AvatarImg1,
      name: 'Roniel',
      position: 'CEO',
      borderColor: '#FF7235',
    },
    {
      message:
        'I started FX trading with TDP last May 2021. With TDP, I can have extra income and at the same time I learn a lot of things about FX trading. Founder & Co-founder together with their Admins are very accommodating, & very approachable. Thank you TDP Family.',
      image: AvatarImg2,
      name: 'Rosal',
      position: 'CEO',
      borderColor: '#FFBE21',
    },
    {
      message:
        'In TraderDoPH, great, brilliant and supportive Admins thinks to create and made my trading more easy and so comfortable. Indeed, a worry free trading partner that would brings to everyones blessing and wonderful life. Super Big Thanks, more power and salute to all of you!!!!!!',
      image: AvatarImg3,
      name: 'Albert',
      position: 'CEO',
      borderColor: '#4756DF',
    },
    // {
    //   message:
    //     'Eleifend fames amet, fames enim. Ullamcorper pellentesque ac volutpat nibh aliquet et, ut netus. Vel, fringilla sit eros pretium',
    //   image: AvatarImg4,
    //   name: 'Aubrey Sanford',
    //   position: 'CEO',
    //   borderColor: '#3EC1F3',
    // },
    // {
    //   message:
    //     'Eleifend fames amet, fames enim. Ullamcorper pellentesque ac volutpat nibh aliquet et, ut netus. Vel, fringilla sit eros pretium',
    //   image: AvatarImg5,
    //   name: 'Terri Conroy',
    //   position: 'CEO',
    //   borderColor: '#BB7259',
    // },
  ],
};

export const cta = {
  title: 'Thousand of users for this Expert Advisor',
  subtitle: 'Try demo for 7 days with full features.',
  btnText: 'Try free demo',
  img1: 'https://traderdoph.com/images/traderdoph_rakkpro.png',
  img2: 'https://traderdoph.com/images/MARS.png',
  subMars: 'M.A.R.S (Multiple Asset Risk Specialization) is a powerful tool. This will automate your trading and it has a money management feature using the MT5 platform. MARS strategy is greatly different from an ordinary Expert Advisor with martingale, hedging, average calculation, and grid distance. MARS is a trend follower and equipped with capital risk management. Each open trade has a stop loss to prevent drawdown. This Expert Advisor is not affected by manual orders initiated by traders.',
  subRakk: "Whether you're a beginner or just got curious about trading, TraderDoPH can walk you through it. Easy guide and step-by-step process are available to assist you with a smooth and safe set-up for your trading needs. We made customized strategies patterned to the likes of Martingale, Hedging, Averaging and Grid Distance calculation to optimize results and prevent losses during trading. Our EA (Expert Advisor) set-up can overcome dizzy market movements, giving a security margin for your funds.",
};

export const footer = {
  logo: LogoImg,
  links: [

    { name: 'About us', href: '/' },
    { name: 'Achievements', href: '/achievements' },
    { name: 'FAQ', href: '/faq' },
    { name: 'Testimonials', href: '/testimonials' },
    { name: 'Blog', href: '/' },
  ],
  legal: [
    { name: 'Terms of use', href: '/' },
    { name: 'Terms of conditions', href: '/' },
    { name: 'Privacy policy', href: '/' },
    { name: 'Cookie policy', href: '/' },
  ],
  newsletter: {
    title: 'Newsletter',
    subtitle1: 'Subscribe to our news letter,',
    subtitle2: 'to receive latest update about traderdoph.',
  },
  form: {
    placeholder: 'Enter your email',
    btnText: 'Subscribe',
    smallText: 'We don’t sell your email and spam',
  },
};

export const copyright = {
  link1: {
    name: 'Privacy & Terms',
    href: '/privacy',
  },
  link2: {
    name: 'Contact us',
    href: '/contact-us',
  },
  copyText: 'Copyright © 2023 | TraderDoPH',
  social: [
    { icon: FacebookIcon, href: '/' },
    { icon: TwitterIcon, href: '/' },
    { icon: LinkedinIcon, href: '/' },
  ],
};

export const sponsorAdmin = {
  name: [
    '',
    '@norki',
    '@Nilo',
    '@kaori',
    '@Robert',
    'FAWN',
    'edWOW13',
    '¥ all is well ¥',
    'PIPSquad',
    'badett',
    'CapitanaMau14',
    'Mikay'

  ],
  account: [
    '',
    'FBS',
    'Exness',
    'XM',
    'Litefinance'
  ]

}
